import { tWithKeyAttr as t } from "../../../i18nHelper";
import styles from "./programDatesPopup.module.css";
import reportsIcon from "../../../images/reports_icon.svg";
import { useEffect, useState } from "react";
import Modal from "../modal/Modal";
import useMediaQuery from "../../../hooks/useMediaQuery";
import { mobileWidth, week } from "../../../utils/constants";
import Loader from "../../loader/loader";
import GeneralErrorPopup from "../errorPopup/errorPopup";
import {
  IAppointment,
  TAppointmentsProgramsData,
} from "../../../services/types/utils.types";
import { useGetAppointmentsProgramsScheduleMutation } from "../../../services/api/utils.api";
import { isDateAfterToday } from "../../../utils/utils";

interface ProgramDatesPopupProps {
  treatmentPlan: TAppointmentsProgramsData;
  onClose?: () => void;
  onFullClose?: () => void;
}
function ProgramDatesPopup({ treatmentPlan }: ProgramDatesPopupProps) {
  const [programDates, setProgramDates] = useState<IAppointment[] | null>(null);
  const [programStatus, setProgramStatus] = useState<string>("");
  const [openErrorModal, setOpenErrorModal] = useState<boolean>(false);

  const [getAllAppointments, isLoading] =
    useGetAppointmentsProgramsScheduleMutation();
  const mobile = useMediaQuery(mobileWidth);

  useEffect(() => {
    const { usersId, therapistsId, ...restAppointmentsProgram } =
      treatmentPlan.appointmentsProgram;

    getAllAppointments(restAppointmentsProgram).then((res) => {
      if ("data" in res && res?.data) {
        const mappedTimesInData = res.data.map((app) => {
          return {
            ...app.appointments,
            startTime: app.appointments.startTime
              ?.split(":")
              .slice(0, 2)
              .join(":"),
            endTime: app.appointments.endTime?.split(":").slice(0, 2).join(":"),
            isReport: app.isReport,
          };
        });
        const sortedTimes = mappedTimesInData
          .filter((item) => item.statusId)
          .sort((a, b) => {
            const dateA = new Date(a?.appointmentDate).getTime();
            const dateB = new Date(b?.appointmentDate).getTime();
            return dateA - dateB;
          });

        setProgramDates(sortedTimes);
        if (sortedTimes.length > 0) {
          const startProgram = isDateAfterToday(
            new Date(sortedTimes[0].appointmentDate)
          );
          if (!startProgram) {
            if (sortedTimes[0].isReport) {
              const unReportedMeeting = sortedTimes.find(
                (ap) =>
                  !isDateAfterToday(new Date(ap.appointmentDate)) &&
                  !ap.isReport
              );
              if (unReportedMeeting) {
                setProgramStatus(t('UNREPORTED_MEETING'));
              } else {
                setProgramStatus(t('MEETINGS_STARTED'));
              }
            } else {
              setProgramStatus(t('UNREPORTED_MEETING'));
            }
          } else {
            setProgramStatus(t('NO_MEETINGS_YET'));
          }
        }
      }
    });
  }, [treatmentPlan, getAllAppointments]);

  return (
    <div className={styles.popup}>
      <article className={styles.popupArticle}>
        <h2 className={styles.popup__title}>{t('PROGRAM_MEETING_DATES')}</h2>
        {programStatus && (
          <h2 className={styles.popup__text}>{t('PROGRAM_STATUS:')}{programStatus}</h2>
        )}
        {programDates && programDates.length > 0 && (
          <ul className={styles.inquiries}>
            <li className={`${styles.inquiry} ${styles.inquiryHeader}`}>
              <p className={`${styles.inquiryCell} ${styles.inquiryNumber}`}>
                {mobile ? t('NUMBER_1') : t('MEETING_NUMBER')}{" "}
              </p>
              <p className={`${styles.inquiryCell} ${styles.inquiryDate}`}>
                {t('DATE')}{" "}
              </p>
              <p className={`${styles.inquiryCell} ${styles.inquiryWeekDay}`}>
                {t('DAY_OF_WEEK')}{" "}
              </p>
              <p className={`${styles.inquiryCell} ${styles.inquiryName}`}>
                {mobile ? t('START') : t('START_TIME')}{" "}
              </p>
              <p className={`${styles.inquiryCell} ${styles.inquiryCycle}`}>
                {mobile ? t('SIYUM') : t('END_TIME')}{" "}
              </p>
              <p className={`${styles.inquiryCell} ${styles.inquiryContent}`}>{t('REPORT')}</p>
            </li>
          </ul>
        )}

        <div className={`${styles.datesContainer}`}>
          {programDates && programDates.length > 0 ? (
            programDates.map((date, index) => {
              const isdateAfterToday = isDateAfterToday(
                new Date(date.appointmentDate)
              );
              return (
                <li
                  key={index}
                  className={`${styles.inquiry} ${
                    index % 2 === 0 && styles.inquiry_colored
                  }`}
                >
                  <p
                    className={`${styles.inquiryCell} ${styles.inquiryNumber}`}
                  >
                    {index + 1}{" "}
                  </p>
                  <p className={`${styles.inquiryCell} ${styles.inquiryDate}`}>
                    {new Date(date.appointmentDate).toLocaleDateString("en-GB")}{" "}
                  </p>
                  <p
                    className={`${styles.inquiryCell} ${styles.inquiryWeekDay}`}
                  >
                    {week[new Date(date.appointmentDate).getDay()]}{" "}
                  </p>
                  <p className={`${styles.inquiryCell} ${styles.inquiryName}`}>
                    {date.startTime?.split(":").slice(0, 2).join(":")}
                  </p>
                  <p className={`${styles.inquiryCell} ${styles.inquiryCycle}`}>
                    {date.endTime?.split(":").slice(0, 2).join(":")}
                  </p>

                  {!date.isReport ? (
                    <p
                      className={`${styles.inquiryCell} ${styles.btn_take}
                          ${!isdateAfterToday && styles.not_exist_report}`}
                    >
                      {isdateAfterToday
                        ? t('MEETING_NOT_HELD')
                        : t('ACTION_REPORT_MISSING')}
                    </p>
                  ) : (
                    <img
                      src={reportsIcon}
                      alt={t('ACTION_REPORT')}
                      title={t('ACTION_REPORT')}
                    />
                  )}
                </li>
              );
            })
          ) : isLoading.isLoading ? (
            <div className={styles.text}>
              <Loader />
            </div>
          ) : (
            <p className={styles.text}>{t('NO_DATES_FOUND')}</p>
          )}
        </div>

        {openErrorModal && (
          <Modal onClose={() => setOpenErrorModal(false)}>
            <GeneralErrorPopup onClose={() => setOpenErrorModal(false)} />
          </Modal>
        )}
      </article>
    </div>
  );
}

export default ProgramDatesPopup;
